import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { warehouseActions } from "../../../../../store/slices/warehouse";
import { workerActions } from "../../../../../store/slices/workers";
import { generateGreylist2 } from "../../../../../utility/misc/remoteSelection";
import { rootsDataId } from "./getMachineStatus";

export const postGreylistsId = "postGreylists";

const UIText = {
  "es-CL": { success: "Selección guardada exitosamente" },
  "en-US": { success: "Selection saved successfully" },
};

const clonerHandlers = {
  addRepo: ":5107/repo/add",
  resumeRepo: ":5107/repo/resume",
  setRepo: ":5107/repo/greylist/set",
};

const cloner365Handlers = {
  addRepo: ":5111/remote/repo/add",
  resumeRepo: ":5111/remote/repo/resume",
  setRepo: ":5111/remote/repo/greylist/set",
};

const postGreylists = ({
  server,
  M365server,
  tunnelToken,
  password,
  trees,
  roots,
  locale,
  is365device,
}) => {
  return async (dispatch) => {
    const { success } = UIText[locale];
    // dispatch(workerActions.start(postGreylistsId));

    let handlers;
    // const is365device = !!c365ID;
    if (is365device) {
      handlers = cloner365Handlers;
    } else {
      handlers = clonerHandlers;
    }

    try {
      let url;
      let url2;
      let url3;
      if (is365device) {
        const base = M365server.split(":");
        url = base[0] + ":" + base[1] + handlers.addRepo;
        url2 = base[0] + ":" + base[1] + handlers.resumeRepo;
        url3 = base[0] + ":" + base[1] + handlers.setRepo;
      } else {
        url = server.slice(0, -1) + handlers.addRepo;
        url2 = server.slice(0, -1) + handlers.resumeRepo;
        url3 = server.slice(0, -1) + handlers.setRepo;
      }
      let newRoots = [];
      console.log("roots to post greylists", roots);
      // console.log("trees",trees)
      for (const root of roots) {
        if (!trees[root.root]) {
          newRoots.push(root);
          continue;
        }
        
        let newRoot = { ...root };
        if (root.id || trees[root.root][0].backup) {
          if (!root.id) {
            console.log("initialize repository", root.root);
            let formData = new FormData();
            formData.append("name", root.root);
            formData.append("path", root.root);
            const response = await axios.post(url, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                tunnel_token: tunnelToken,
              },
            });
            newRoot.id = response.data.id;

            let formData2 = new FormData();
            formData2.append("id", newRoot.id);
            await axios.post(url2, formData2, {
              headers: {
                "Content-Type": "multipart/form-data",
                tunnel_token: tunnelToken,
              },
            });
          }

          const gl = generateGreylist2(trees[root.root], [0]);
          let formData = new FormData();
          formData.append("id", newRoot.id);
          formData.append("path", JSON.stringify(gl));
          formData.append("cpass", password);
          await axios.post(url3, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              tunnel_token: tunnelToken,
            },
          });
        }
        newRoots.push(newRoot);
      }
      dispatch(warehouseActions.load({ id: rootsDataId, data: newRoots }));
      dispatch(workerActions.finish({ id: postGreylistsId }));
      enqueueSnackbar(success, { variant: "success" });
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id: postGreylistsId, error: e.message }));
      enqueueSnackbar(e.message, { variant: "error" });
    }
  };
};

export default postGreylists;
